var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env!=='development')?_c('div',[_vm._v(" "+_vm._s(_vm.$t('errormessage'))+" ")]):_c('div',{staticClass:"card errorblock"},[_c('div',{staticClass:"card-header"},[_vm._v("Errors : Debug View")]),_c('div',{staticClass:"card-body"},[_vm._v(" "+_vm._s(_vm.errors)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }